import { DanaSendPayslipEmailApiParameter, sendPackingSlipEmail } from "@dana/Services/DanaOrderRelatedService";
import { OrderPackingSlip } from "@dana/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,    
} from "@insite/client-framework/HandlerCreator";

type PostPackingSlipEmailParameter = {
    recipientEmailAddress?: string;
    orderPackingSlipResponse?: OrderPackingSlip;
    packingHtml:string;
  
}& HasOnSuccess<any> & HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<PostPackingSlipEmailParameter, DanaSendPayslipEmailApiParameter>;

export const SendDataToApi: HandlerType = async props => {
   await sendPackingSlipEmail({
        recipientEmailAddress:props.parameter.recipientEmailAddress,  
        orderPackingSlipResponse: props.parameter.orderPackingSlipResponse,
        packingHtml:props.parameter.packingHtml,
        
    });
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [SendDataToApi];

const PostPackingSlipEmailHandler = createHandlerChainRunner(chain, "PostPackingSlipEmailHandler");
export default PostPackingSlipEmailHandler;